import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { CHECKOUT_FEATURE, CheckoutState, StateWithCheckout } from '../checkout-state';

export const getCheckoutState: MemoizedSelector<StateWithCheckout, CheckoutState> =
  createFeatureSelector<CheckoutState>(CHECKOUT_FEATURE);
